/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { NetworkMemberResponseKind } from './networkMemberResponseKind';
import type { NetworkMemberResponseStatus } from './networkMemberResponseStatus';
import type { NetworkUserRef } from './networkUserRef';

export interface NetworkMemberResponse {
  id?: string | null;
  kind: NetworkMemberResponseKind;
  user_id?: string | null;
  name: string;
  email?: string | null;
  avatar_url?: string | null;
  is_me: boolean;
  linkedin_url?: string | null;
  profile_found?: boolean | null;
  connections_uploaded_at?: string | null;
  connections_count?: number;
  matched_connections_count?: number;
  overlaps_count?: number;
  computed_at?: string | null;
  status: NetworkMemberResponseStatus;
  created_by?: NetworkUserRef | null;
}
